import { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import { connect } from "react-redux";
import {
  getEmployeeToVote,
  getMyVotes,
  submitVote,
} from "../../../store/voting/actions";
import AlertDialog from "../../profile/components/AlertDialog";
import { showError } from "../../toastify";

const VotingIDCForm = (props) => {
  const {
    setShowVotingForm,
    user,
    loading,
    myVotes,
    getMyVotes,
    getEmployeeToVote,
    submitVote,
  } = props;
  const [loadingVotes, setLoadingVotes] = useState(true);
  const [loadingEmployees, setLoadingEmployees] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [wasVoted, setWasVoted] = useState(null);
  const [employeeToVote, setEmployeeToVote] = useState([]);
  const [filteredEmployeeToVote, setFilteredEmployeeToVote] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [confirmSubmit, setConfirmSubmit] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    if (myVotes.length === 0) {
      getMyVotes(setLoadingVotes, 2);
    } else setLoadingVotes(false);

    if (employeeToVote.length === 0) {
      getEmployeeToVote((status, data) => {
        setLoadingEmployees(status);
        setEmployeeToVote(data);
      }, 2);
    } else setLoadingEmployees(false);

    return () => {
      setLoadingVotes(true);
      setLoadingEmployees(true);
    };
  }, []);

  useEffect(() => {
    if (!!myVotes.length) {
      setWasVoted(
        !!myVotes.find((item) => item.fiscalYearId === user?.RBM_fiscalYear?.id)
      );
    } else setWasVoted(false);
  }, [myVotes]);

  useEffect(() => {
    const filtered = [...employeeToVote].filter(({ names }) =>
      (names || "").toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredEmployeeToVote(filtered);
  }, [searchTerm, employeeToVote]);

  const onClean = () => {
    // clean all states before close
    setSelectedEmployee(null);
    setWasVoted(null);

    setShowVotingForm();
  };

  const onClose = () => {
    // clean all states before close
    onClean();
    setShowVotingForm();
  };

  const handleSubmitVote = () => {
    // handle validation
    if (!selectedEmployee) {
      showError("Please selected employee you're voting for!");
      return;
    }

    const formData = {
      employeePositionId: selectedEmployee?.id,
      groupDetailId: selectedEmployee?.groupDetailId,
        groupType:2
    };
    submitVote(formData, (status, res) => {
      setIsSubmitting(status);
      if (!status && !!res) onClean();
    });
  };

  const onSearchEmployee = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
  };

  const isFormComplete = selectedEmployee;

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="vote-dialog-title"
        open={true}
        fullWidth
        maxWidth="md"
        PaperProps={{
          style: {
            borderRadius: "16px",
            padding: "20px",
          },
        }}
      >
        <DialogTitle>
          <Typography variant="h6">
          Voting Form for the Internal Disciplinary Committee /{" "}
            <Chip label={user?.RBM_fiscalYear?.name} color="primary" />
          </Typography>
          <Box display="flex" alignItems="center" gap={2} mt={1}>
            {!loadingEmployees && !!employeeToVote.length && (
              <div className="row w-100 mt-2 ml-1" ref={containerRef}>
                <div className="col-12">
                  <div className="card service-card valid mb-2 mt-1 w-100">
                    <div
                      className="card-header"
                      style={{ padding: "0.25rem 1.2rem" }}
                    >
                      Select the employee you want to vote for in the {employeeToVote[0].groupName} category.
                     
                    </div>
                    <div className="card-body">
                      <div className="px-2 pt-2">
                        <TextField
                          label="Search Employee by names"
                          variant="outlined"
                          size="small"
                          disabled={!employeeToVote.length}
                          onChange={onSearchEmployee}
                          className="mr-2 w-100"
                        />
                      </div>
                      <List
                        sx={{
                          width: "100%",
                          bgcolor: "background.paper",
                          maxHeight: "300px",
                          overflowY: "auto",
                        }}
                      >
                        {filteredEmployeeToVote.map(
                          ({
                            id,
                            employeeId,
                            names,
                            postionName,
                            unitName,
                            groupDetailId
                          }) => {
                            const labelId = `checkbox-list-label-${id}`;

                            return (
                              <>
                                <ListItem
                                  key={id}
                                  disablePadding
                                  style={{
                                    backgroundColor: `${
                                      selectedEmployee?.id === id
                                        ? "#e9ecef"
                                        : ""
                                    }`,
                                  }}
                                >
                                  <ListItemButton
                                    role={undefined}
                                    onClick={() =>
                                      setSelectedEmployee(
                                        selectedEmployee?.id === id
                                          ? null
                                          : {
                                              id,
                                              employeeId,
                                              names,
                                              postionName,
                                              unitName,
                                              groupDetailId
                                            }
                                      )
                                    }
                                    dense
                                  >
                                    <ListItemIcon>
                                      <Checkbox
                                        edge="start"
                                        checked={selectedEmployee?.id === id}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{
                                          "aria-labelledby": labelId,
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      id={labelId}
                                      primary={names}
                                      secondary={
                                        <strong
                                          className={`d-flex align-items-center text-dark text-uppercase `}
                                          style={{
                                            cursor: "default",
                                            borderRadius: "8px",
                                            fontSize: "10px",
                                          }}
                                        >
                                          Position:
                                          <span
                                            className={`badge badge-secondary ml-1`}
                                          >
                                            {postionName}
                                          </span>
                                        </strong>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                                <Divider />
                              </>
                            );
                          }
                        )}
                      </List>
                    </div>
                  </div>
                </div>

                <div ref={bottomRef}></div>
              </div>
            )}
            {loadingEmployees && (
              <>
                {Array(8)
                  .fill(0)
                  .map((_, index) => (
                    <div className="col-12 mb-4" key={index}>
                      {/* Skeleton Card */}
                      <Card className="vote-card rounded h-100 border">
                        <CardContent>
                          <Box display="flex" alignItems="center" mb={2}>
                            <Skeleton
                              variant="circular"
                              width={40}
                              height={40}
                            />
                            <Box ml={2} flex="1">
                              <Skeleton width="80%" height={24} />
                              <Skeleton width="60%" height={20} />
                            </Box>
                          </Box>

                          <Skeleton width="60%" height={20} />
                          <Skeleton width="70%" height={20} />
                          <Skeleton width="50%" height={20} />
                          <Skeleton width="60%" height={20} />

                          <Box mt={2} mb={2}>
                            <Skeleton
                              variant="rectangular"
                              width="100px"
                              height={24}
                            />
                          </Box>

                          <Skeleton width="80%" height={20} />

                          <Box mt={3}>
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={36}
                            />
                          </Box>
                        </CardContent>
                      </Card>
                    </div>
                  ))}
              </>
            )}
            {!loadingEmployees && !employeeToVote.length && (
              <>
                <div className="col text-center mt-5">
                  <Typography variant="h6" color="textSecondary" gutterBottom>
                    😕 Voting is now closed for the {user?.RBM_fiscalYear?.name} fiscal year. 
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Couldn’t find any employees to vote for.
                  </Typography>
                </div>
              </>
            )}
          </Box>
        </DialogTitle>

        <DialogActions className="d-flex justify-content-between mt-3">
          <Button
            variant="outlined"
            onClick={onClose}
            fullWidth
            sx={{ borderRadius: 2 }}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setConfirmSubmit(true)}
            fullWidth
            sx={{ ml: 2, borderRadius: 2 }}
            disabled={!isFormComplete || isSubmitting || !!wasVoted}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      {!!confirmSubmit && (
        <AlertDialog
          status={true}
          handleClose={() => setConfirmSubmit(false)}
          handleConfirm={() => handleSubmitVote()}
          title="Are you sure you want to submit your vote?"
          desc="Once votes are submitted, you cannot undo your action!"
          disabled={loading || loadingVotes || isSubmitting}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ loading, user, myVotes }) => {
  return {
    loading,
    user,
    myVotes,
  };
};

export default connect(mapStateToProps, {
  getMyVotes,
  getEmployeeToVote,
  submitVote,
})(VotingIDCForm);
